import { Link } from 'office-ui-fabric-react';
import * as React from 'react';
import styled from 'styled-components';

export interface ISkipLinkProps {
  elementId: string;
}

const StyledDiv = styled.div`
  .m-skip-to-main {
    left: -999px;
    position: absolute;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
    z-index: -2;
  }

  .m-skip-to-main:hover {
    left: -999px;
    position: absolute;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
    z-index: -2;
  }

  .m-skip-to-main:focus,
  .m-skip-to-main:active {
    background: #e6e6e6;
    color: #0067b8;
    position: fixed;
    top: 0;
    left: 0;
    width: auto;
    height: auto;
    overflow: auto;
    right: 0;
    text-decoration: underline;
    text-align: center;
    z-index: 800;
    outline: none;
    line-height: 43px;
  }

  .m-skip-to-main:focus {
    border: 1px dashed #000;
  }
`;

export const SkipLink = (props: React.PropsWithChildren<ISkipLinkProps>) => {
  return (
    <StyledDiv id="skip-link-container">
      <Link className="m-skip-to-main" href={`#${props.elementId}`}>
        {props.children}
      </Link>
    </StyledDiv>
  );
};
